module.exports = __webpack_public_path__ + "static/up42-fc6ebe6d466391ec6c8ee5e6992e7e7c.png";